import React from 'react';
import { AlertTriangle } from 'lucide-react';
import logger from '../../utils/logger';
import Button from '../ui/Button';
import { captureProductionException } from '../../observability/productionTelemetry';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('ErrorBoundary caught an error:', error, errorInfo);
    captureProductionException(error, {
      boundary: 'app',
      componentStackPresent: Boolean(errorInfo?.componentStack),
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4" style={{
          background: `
            radial-gradient(900px circle at 50% 15%, rgba(230, 223, 195, 0.08), transparent 55%),
            linear-gradient(180deg, var(--color-bg), var(--color-bg-secondary))
          `
        }}>
          <div className="max-w-md w-full bg-[var(--color-surface)]/95 backdrop-blur-xl rounded-2xl p-8 border border-scarpa/35 shadow-2xl text-center">
            <div className="w-16 h-16 bg-[rgba(230,223,195,0.12)] rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-10 h-10 text-stark" />
            </div>
            <h2 className="text-2xl font-bold text-stark mb-2">Something went wrong</h2>
            <p className="text-grayish mb-6">
              An unexpected error occurred. Please refresh the page to try again.
            </p>
            <Button
              type="button"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
